import React, { Component } from "react";
import axios from "axios";
import { configuration } from "../../appConfig";
import ".././newstyle.css";
import "../../views/Dashboard/qrlist.css";
import { connect } from "react-redux";
import fallbackAdiLogo from "../../assets/img/brand/Adi.png";

class ReportFooter_Swiss extends Component {
  state = {
    insurenceProviderInfo: {},
    words: {},
    lang: "",
    fallbackInfo: {},
    insuranceName: "",
    jsonData: {},
    data: ""
  };

  async componentDidMount() {
    await this._getData();
    await this.getFallbackDetails();
    await this.getInsuranceName();
    await this.getInsurenceClients();
    this.getLang();
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      const lang = localStorage.getItem("lang");
      this.setState({ lang, words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    const currentLang = (this.props.reportType === 'newReportFull' && lang === 'fr') ? 'ch-fr' : lang;
    return words[word] ? words[word][currentLang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    }
    return null;
  }

  getFallbackDetails = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const url = `${configuration.getFallbackDetails}?partner_id=${partnerId}`;
    try {
      const res = await axios.get(url);
      if (res.data.success !== false) {
        this.setState({
          fallbackInfo: {
            Logo: res.data.company_logo
              ? `${configuration.getFallbackLogoPath}${partnerId}/${res.data.company_logo}`
              : fallbackAdiLogo,
            Email: res.data.company_email || "sales@adi-gmbh.com",
            CompanyName: res.data.company_name || "Auto Damage Inspection GmbH",
            Website: res.data.company_website || "https://adi-gmbh.com",
            Address: res.data.company_address || "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
            PrimaryColor: res.data.primary_color || "#FF0000",
            SecondaryColor: res.data.secondary_color || "#000000",
            PrimaryContact: res.data.contact_number || "08954809487",
            RegisterNo: res.data.company_registration_number || "HRB1234",
          }
        });
      } else {
        this.setState({
          fallbackInfo: {
            Logo: fallbackAdiLogo,
            Email: "sales@adi-gmbh.com",
            CompanyName: "Auto Damage Inspection GmbH",
            Website: "https://adi-gmbh.com",
            Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
            PrimaryColor: "#FF0000",
            SecondaryColor: "#000000",
            PrimaryContact: "08954809487",
            RegisterNo: "HRB1234",
          }
        });
      }
    } catch (error) {
      console.error("Error fetching fallback details:", error);
      this.setState({
        fallbackInfo: {
          Logo: fallbackAdiLogo,
          Email: "sales@adi-gmbh.com",
          CompanyName: "Auto Damage Inspection GmbH",
          Website: "https://adi-gmbh.com",
          Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
          PrimaryColor: "#FF0000",
          SecondaryColor: "#000000",
          PrimaryContact: "08954809487",
          RegisterNo: "HRB1234",
        }
      });
    }
  };

  getInsuranceName = async () => {
    const { jsonData } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile").split("_")[0];

    if (jsonData.InsurenceName && jsonData.InsurenceName.trim() !== "") {
      localStorage.setItem("InsurenceName", jsonData.InsurenceName);
      this.setState({ insuranceName: jsonData.InsurenceName });
    } else if (partnerId) {
      const url = `${configuration.getCustomerInfo}?partnerId=${partnerId}&vin=${vin}`;
      try {
        const res = await axios.get(url);
        if (res.data.length) {
          const fetchedInsuranceName = res.data[0].InsurenceName || "";
          localStorage.setItem("InsurenceName", fetchedInsuranceName);
          this.setState({ insuranceName: fetchedInsuranceName });
        } else {
          localStorage.setItem("InsurenceName", "");
          console.warn("No insurance name found in getCustomerInfo response.");
        }
      } catch (error) {
        console.error("Error fetching insurance name:", error);
        localStorage.setItem("InsurenceName", "");
      }
    } else {
      localStorage.setItem("InsurenceName", "");
    }
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const { insuranceName, fallbackInfo } = this.state;

    if (insuranceName.toLowerCase() === 'null') {
      insuranceName = null;
    }

    if (insuranceName && partnerId) {
      const url = `${configuration.getInsurenceClients}?partnerId=${partnerId}`;
      try {
        const res = await axios.get(url);
        if (res.data && Array.isArray(res.data)) {
          const insuranceProvider = res.data.find(
            data => data.Name.toLowerCase() === (insuranceName || "").toLowerCase()
          );

          if (insuranceProvider && insuranceProvider.Logo) {
            insuranceProvider.Logo = `${configuration.imagePath}/scanImages/${partnerId}/insurenceClients/${insuranceProvider.Logo}`;
          }

          this.setState({
            insurenceProviderInfo: insuranceProvider || fallbackInfo
          });
        } else {
          console.warn("Invalid data format received from getInsurenceClients API.");
          this.setState({ insurenceProviderInfo: fallbackInfo });
        }
      } catch (error) {
        console.error("Error fetching insurance clients:", error);
        this.setState({ insurenceProviderInfo: fallbackInfo });
      }
    } else {
      console.warn("No partnerId found in localStorage.");
      this.setState({ insurenceProviderInfo: fallbackInfo });
    }
  };

  _getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    try {
      const response = await axios.get(`${configuration.getData}?vin=${vin}&partnerId=${partnerId}`);
      if (response.data) {
        const { Datetime, InsurenceName } = response.data;
        this.setState({
          data: Datetime,
          jsonData: response.data,
          insuranceName: InsurenceName || ""
        });
      } else {
        console.warn("No data received from getData API.");
      }
    } catch (error) {
      console.error("Error fetching main data:", error);
    }
  };

  _onImageError = () => {
    this.setState(prevState => ({
      insurenceProviderInfo: {
        ...prevState.insurenceProviderInfo,
        Logo: require("../../assets/img/brand/logo.png")
      }
    }));
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    const { insurenceProviderInfo, fallbackInfo, data } = this.state;
    const date = new Date();

    
    // const linearGradient = this.state.fallbackInfo.PrimaryColor
    // ? `linear-gradient(45deg, ${this.state.fallbackInfo.PrimaryColor} 50%,hsla(0,0%,100%,0) 0`
    // : 'linear-gradient(45deg  , #D92029, hsla(0,0%,100%,0) 0)'  ;
    // Utility function for formatting date
    const formatDate = (data) => {
      if (!data) return '';
      const [year, month, day, hours, minutes] = data.split("_");
      const formattedDate = client === "US" || client === "CANADA"
        ? `${month}/${day}/${year} | ${hours}:${minutes}`
        : `${day}.${month}.${year} / ${hours}:${minutes}`;
      return formattedDate;
    };

    // Determine the primary color
    const primaryColor = insurenceProviderInfo.PrimaryColor || fallbackInfo.PrimaryColor || '#D92029';

    // Set linear gradient
    const linearGradient = `linear-gradient(45deg, ${primaryColor} 50%, hsla(0,0%,100%,0) 0)`;

    return (
      <>
        <div className="bottom-footer-wrapper">
          <div className="report-footer-wrapper">
            <div className="container-fluid p-0 information-footer-top-wrapper">
              {((this.props.pageNo === 1 || this.props.pageNo === 2) && (client === "SWISS" || client === "POLAND")) && (
                <div className="report-footer-main-row row report-footer-details-wrapper p-0">
                  <div className="col-12 information-footer-col-wrapper p-0">
                    <div className="row p-0 information-footer-row-wrapper">
                      {/* First Column - Logo and Website */}
                      <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 infomation-right-block-border information-footer-col" style={{ borderRight: `4px solid ${primaryColor}` }}>
                        <div className="footer-client-logo-one">
                          <img width="100%" src={fallbackInfo.Logo} alt="Company Logo" />
                        </div>
                        <div className="footer-website-details-wrapper">
                          <h4 className="footer-website-text">{fallbackInfo.Website}</h4>
                          {/* <h4 className="footer-website-text">{insurenceProviderInfo.Website || fallbackInfo.Website}</h4> */}
                        </div>
                      </div>

                      {/* Second Column - Address and Contact Details */}
                      <div className="col-lg-4 col-md-6 col-sm-6 col-12 p-0 infomation-right-block-border footerAddressBox_wrapper information-footer-center-col" style={{ borderRight: `4px solid ${primaryColor}` }}>
                        <div className="footerAddress_Details">
                          <h4 className="footer-address-title">{fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}</h4>
                          {/* <h4 className="footer-address-title">{insurenceProviderInfo.Name || fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}</h4> */}
                          <h6 className="footer-address-light-text">{fallbackInfo.Address}</h6>
                          {/* <h6 className="footer-address-light-text">{insurenceProviderInfo.Address || fallbackInfo.Address}</h6> */}
                          <div className="footer-contact-details">
                            <span>{fallbackInfo.PrimaryContact}</span>
                            {/* <span>{insurenceProviderInfo.PrimaryContact || fallbackInfo.PrimaryContact}</span> */}
                            <span className="address-line-border" style={{ borderRight: `4px solid ${primaryColor}` }}></span>
                            <span>{fallbackInfo.Email}</span>
                            {/* <span>{insurenceProviderInfo.Email || fallbackInfo.Email}</span> */}
                          </div>
                        </div>
                      </div>

                      {/* Third Column - Partner-Specific Logo */}
                      <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 information-footer-col">
                        <div className="footer-client-logo-two">
                          {partnerId !== '10-200410' && partnerId !== '21-220221' && <img className="w-100" src={require("../../assets/img/brand/dns-adi.jpg")} alt="DNS ADI Logo" />}
                          {(partnerId === '10-200410' || partnerId === '21-220221') && <img className="w-100" src={require("../../assets/img/brand/Report-footer.png")} alt="Report Footer Logo" />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="container-fluid information-footer-top-wrapper">
              {client !== "SWISS" && client !== "POLAND" && (
                <div className="no-fix-footer row report-footer-details-wrapper p-0">
                  <div className="col-12 information-footer-col-wrapper p-0">
                    <div className="row p-0 information-footer-row-wrapper">

                      {/* First Column - Logo and Website */}
                      <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 infomation-right-block-border information-footer-col" style={{ borderRight: `4px solid ${primaryColor}` }}>
                        <div className="footer-client-logo-one">
                          <img width="100%" src={fallbackInfo.Logo} alt="Company Logo" />
                        </div>
                        <div className="footer-website-details-wrapper">
                          <h4 className="footer-website-text">{fallbackInfo.Website}</h4>
                          {/* <h4 className="footer-website-text">{insurenceProviderInfo.Website || fallbackInfo.Website}</h4> */}
                        </div>
                      </div>

                      {/* Second Column - Address and Contact Details */}
                      <div className="col-lg-4 col-md-6 col-sm-6 col-12 p-0 infomation-right-block-border footerAddressBox_wrapper information-footer-center-col" style={{ borderRight: `4px solid ${primaryColor}` }}>
                        <div className="footerAddress_Details">
                          <h4 className="footer-address-title">{fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}</h4>
                          {/* <h4 className="footer-address-title">{insurenceProviderInfo.Name || fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}</h4> */}
                          <h6 className="footer-address-light-text">{ fallbackInfo.Address}</h6>
                          {/* <h6 className="footer-address-light-text">{insurenceProviderInfo.Address || fallbackInfo.Address}</h6> */}
                          <div className="footer-contact-details">
                            <span>{fallbackInfo.PrimaryContact}</span>
                            {/* <span>{insurenceProviderInfo.PrimaryContact || fallbackInfo.PrimaryContact}</span> */}
                            <span className="address-line-border" style={{ borderRight: `4px solid ${primaryColor}` }}></span>
                            <span>{fallbackInfo.Email}</span>
                            {/* <span>{insurenceProviderInfo.Email || fallbackInfo.Email}</span> */}
                          </div>
                        </div>
                      </div>

                      {/* Third Column - Partner-Specific Logo */}
                      <div className="col-lg-4 col-md-3 col-sm-3 col-12 p-0 information-footer-col">
                        <div className="footer-client-logo-two">
                          {partnerId !== '10-200410' && partnerId !== '21-220221' && <img className="w-100" src={require("../../assets/img/brand/dns-adi.jpg")} alt="DNS ADI Logo" />}
                          {(partnerId === '10-200410' || partnerId === '21-220221') && <img className="w-100" src={require("../../assets/img/brand/Report-footer.png")} alt="Report Footer Logo" />}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="container-fluid copy-right-footer-wrapper fixed-copy-right-footer">
              <div className="row copy-right-footer-row">
                <div className="col-12 copy-right-footer-top-col">
                  <div className="row p-0">
                    <div className="col-8 col-md-8 col-sm-12 col-12 copy-right-inner-col copy-right-footer-first-col">
                      <div className="footer-copyRight-text-details" style={{ backgroundColor: primaryColor }}>
                        <p>
                          Copyright<sup>&copy;</sup> <span className="copy-right-span">ADI<sup>&reg;</sup></span> <span className="fullYear copy-right-span">{date.getFullYear()}</span> <span className="copy-right-span">{this.lang("All rights reserved.")}</span>
                          <label>
                            <span className="copy-right-span">DnS: </span> <span>{this.state.jsonData && this.state.jsonData.ScannerNo},</span>
                          </label>
                          <label>
                            <span className="copy-right-span">{this.lang("Date")} |</span> <span>{this.lang("Time")} : </span>{formatDate(data)}
                          </label>
                        </p>
                        <div className="footer-cross-box" style={{ background: linearGradient }}></div>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-12 col-12 copy-right-inner-col footer-black-line copy-right-footer-second-col" style={{ borderBlockColor: insurenceProviderInfo.SecondaryColor || fallbackInfo.secondaryColor }}>
                      <div className="footer-black-bottom-line"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportFooter_Swiss);
